export default "__VITE_ASSET__c6208f5d__"